import { ModalProvider } from '@/context/modal.context';

const withModal = (props) => {
  return <ModalProvider>{props.children}</ModalProvider>;
};

export default withModal;
